import { makeObservable, observable } from 'mobx';

import { Model } from './Model';

export interface IMediaTemporaryModel {
    id?: number;
    name?: string;
    url?: string;
}

export class MediaTemporaryModel extends Model implements IMediaTemporaryModel {
    id = 0;
    name = '';
    url = '';

    constructor(payload: IMediaTemporaryModel = {}) {
        super();

        makeObservable(this, {
            id: observable,
            name: observable,
            url: observable,
        });

        this.update(payload);
    }
}
